export default [
    {
        "error_id": "FL 06",
        "data": [
            {
                "cross_section": "91339"
            },
            {
                "cross_section": "91339"
            },
            {
                "cross_section": "40881"
            },
            {
                "cross_section": "40881"
            }
        ]
    }
]